module.exports = __webpack_public_path__ + "media/images/lp_v6_img12-fb692556cc6133d6c43ec57ba207a050.webp";